import { type ErrorMessage, type PhoneNumber, phoneNumberSchema } from '@1trading/fast-api-domain/forms';

export const EMPTY_PHONE_NUMBER: PhoneNumber = { areaCode: '', mobilePhone: '' };

/** fast-api's shared phone number rules and normalisation, with each part's message */
export const createPhoneNumberSchema = (messages: Record<keyof PhoneNumber, ErrorMessage>) =>
  phoneNumberSchema({ errors: { AREA_CODE_INVALID: messages.areaCode, MOBILE_PHONE_INVALID: messages.mobilePhone } });
